import http from '@yld/yun-utils-http'
import { BASE_URL } from '@yld/yun-utils-host'

const RATE_GATEWAY = 'https://rategateway.htholding.cn'

/** 上报电商运价查询记录 */
export function tosaveSpotSearchRecord(data) {
  return http.post(`${BASE_URL.WG}/api/30018/shop/record/saveSearchRecord`, data)
}

/** 立远获取 Rate 运价查询 Token（同 90039 authToken） */
export function authRateToken(data) {
  return http.post(`${BASE_URL.WG}/api/55002/facade/auth/getToken`, data)
}

/** 立远定制静默登录 rategateway（同 90039 externalSsoLogin） */
export async function externalRateSsoLogin(params = {}) {
  const token = params.token || ''
  const url = `${RATE_GATEWAY}/external/sso/login?token=${encodeURIComponent(token)}`
  const resp = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    mode: 'cors'
  })
  return resp.json()
}
